import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { FormGroupBlock } from "./bs3";

//https://bootsnipp.com/snippets/Wa3np

const InputText = (props) => {
    const { label, ...rest } = props;
    return (
        <FormGroupBlock {...rest} label="">
            <Field name={props.name}>
                {({
                    field: { name, value, onChange, onBlur },
                    form: { setFieldValue, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => (
                    <div className="checkbox checbox-switch switch-success">
                        <label>
                            <input
                                type="checkbox"
                                name={name}
                                checked={value}
                                onChange={(option) => {
                                    if (props.onChange) {
                                        return props.onChange(option);
                                    } else {
                                        return setFieldValue(name, !value);
                                    }
                                }}
                                onBlur={onBlur}
                            />
                            <span></span>
                            {props.label}
                        </label>
                    </div>
                )}
            </Field>
        </FormGroupBlock>
    );
};

InputText.propTypes = {
    name: PropTypes.string.isRequired,
};

export default InputText;
